module.exports = __webpack_public_path__ + "static/img/map-position.ab03d6a9.png";